import {
  SEO_MODULE_GLOBAL,
  SEO_MODULE_PRODUCT,
  SEO_MODULE_CATEGORY,
  SEO_MODULE_CMS,
} from '~~/common/config/SeoConfig.ts';

const seoIdExtractors = {
  product: resourceId => resourceId,
  category: resourceId => resourceId?.matchAll(/[0-9]+/g).next().value?.[0],
  boutique: resourceId => resourceId?.match(/[0-9]*\|([0-9]+)/)?.[1],
  cms_content: resourceId => resourceId,
};
const seoModules = {
  product: SEO_MODULE_PRODUCT,
  category: SEO_MODULE_CATEGORY,
  boutique: SEO_MODULE_CATEGORY,
  cms_content: SEO_MODULE_CMS,
};

export function getSeoModuleFromUrlResource (urlResource, urlResourceStore, to) {
  let seoModule;
  let seoModuleId;
  if (urlResource) {
    const {
      resourceId,
      resourceType,
    } = urlResource;
    seoModule = seoModules[resourceType];
    seoModuleId = seoIdExtractors[resourceType]?.(resourceId);
  }
  if (seoModule === undefined) {
    if (isUrlResourceStoreCurrent(urlResourceStore, to)) {
      seoModule = seoModules[urlResourceStore.data.resourceType];
      seoModuleId = urlResourceStore.data.seoResourceId;
    } else {
      seoModule = SEO_MODULE_GLOBAL;
      seoModuleId = -1;
    }
  }
  return {
    seoModule,
    id: seoModuleId,
  };
}

function isUrlResourceStoreCurrent (urlResourceStore, to) {
  const urlData = urlResourceStore?.data || {};
  return (urlData.resourceType
    && (
      urlData.slug === to.path
      || urlData.slug === to.path.replace(/^\//, '')
    )
  );
}
